import {allLanguages} from '@app/i18n/settings'
import {tagPath} from '@app/[lang]/(common-header-footer)/tags/constants'

export const sessionStartQPKey = 'session-start-screen'
export const sessionStorageAttributesKey = 'session-attributes'

export function getPathAlias(path: string) {
  let page = path
  if (path.includes('/intro')) {
    page = 'intro'
  } else if (path.includes('/get-started/category-selection')) {
    page = 'intro-screen'
  } else if (path.includes('/get-started/start-playing')) {
    page = 'get-started'
  } else if (path.includes('/interstitial')) {
    page = 'ad-interstitial'
  } else if (path.includes('/game-details')) {
    page = 'gamename-details'
  } else if (path.includes('/my-favourites')) {
    page = 'my-favourite'
  } else if (path.includes('/game/')) {
    page = 'game-player'
  } else if (path === '/' || path === '' || allLanguages.some((l) => path === `/${l}`)) {
    page = 'home-page'
  } else if (path.includes('/incorrect-property-id')) {
    page = 'wrong-integration-type'
  } else if (path.includes('/login')) {
    page = 'login'
  } else if (path.includes(`/${tagPath}/`)) {
    page = 'tags'
  } else if (allLanguages.some((l) => path.includes(`/${l}/tags`))) {
    page = 'all-tags'
  } else if (path.includes('/games')) {
    page = 'all-games'
  } else {
    page = '404'
  }
  return page
}
